<div class="list">
	@if (persons().length > 0) {
		@for (person of persons(); track person.id) {
			<a class="link" [routerLink]="[person.id]" [queryParams]="queryParams()">
				<lvr-sponsor-persons-item [person]="person"></lvr-sponsor-persons-item>
			</a>
		}
		<lvr-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="showFirstLastButtons"
			[hidePageSize]="hidePageSize"
			preferenceKey="sponsor-persons-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	} @else {
		<lvr-sponsor-persons-item [sponsorName]="sponsorName()"></lvr-sponsor-persons-item>
	}
</div>
